import styled from 'styled-components';

import { ReactComponent as ApplianceIcon } from 'assets/icons/historic/appliance.svg'
import { ReactComponent as LockerIcon } from 'assets/icons/historic/locker.svg'

interface ICategoryIconProps {
  categoryId: number;
  dark?: boolean;
}

export default function CategoryIcon({ categoryId, dark = false }: ICategoryIconProps) {
  const categoryIcons = {
    1: <LockerIcon />,
    3: <ApplianceIcon />,
  } as {
    [key: number]: JSX.Element;
  }

  const darkCategoryIcons = {
    1: <LockerIcon />,
    3: <DarkApplianceIcon />,
  } as {
    [key: number]: JSX.Element;
  }

  return dark ? (darkCategoryIcons[categoryId] ? darkCategoryIcons[categoryId] : <LockerIcon />) : (categoryIcons[categoryId] ? categoryIcons[categoryId] : <LockerIcon />);
}

const DarkApplianceIcon = styled(ApplianceIcon)`
  filter: invert(100%) hue-rotate(180deg) opacity(0.6);

`
